import { useMemo } from 'react';
import { useBaseOwnerId } from '@rhino-project/core/hooks';
import { useModelIndex } from '@rhino-project/core/hooks';

export const useRosterStatuses = (baseFilter: Record<string, unknown> = {}) => {
  const organization = useBaseOwnerId();

  const filter = useMemo(
    () => ({ organization, ...baseFilter }),
    [baseFilter, organization]
  );

  return useModelIndex('roster_status', {
    filter,
    order: ['order']
  });
};
